// extracted by mini-css-extract-plugin
export default {"action-item":"action-item_tJEuc","activate-button":"activate-button_zGMwj"};